module.exports = __webpack_public_path__ + "img/illustration-3.65a36f86.svg";